/**
 * Hook for accessing the current workspace data
 * Provides the active workspace with full details including slug
 */

import { useQuery } from '@tanstack/react-query';
import { useWorkspaceStore } from '@/hooks/state';
import { workspaceService } from '@/services/workspace';
import { queryKeys } from '@/lib/queryKeys';
import { STALE } from '@/lib/queryPolicy';

export function useWorkspace() {
  const { workspaceId } = useWorkspaceStore();

  const { data: workspace, isLoading, error } = useQuery({
    queryKey: queryKeys.workspace.detail(workspaceId!),
    queryFn: () => workspaceService.getWorkspace(workspaceId!),
    enabled: !!workspaceId,
    staleTime: STALE.stable, // workspace metadata — rarely changes
  });

  return {
    activeWorkspace: workspace,
    isLoading,
    error,
    workspaceId,
  };
}
